<template>
  <div class="points-rule-page">
    <a-card title="积分规则">
      <a-spin :spinning="loading">
        <div class="editor-wrap">
          <quill-editor v-model="contentHtml" :options="editorOptions" />
        </div>
        <a-button type="primary" :loading="saving" @click="save">保存规则</a-button>
      </a-spin>
    </a-card>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { getPointsRule, savePointsRule } from '@/api'

export default {
  name: 'PointsRule',
  components: { quillEditor },
  data() {
    return {
      loading: false,
      saving: false,
      contentHtml: '',
      editorOptions: {
        placeholder: '请输入积分规则',
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ color: [] }, { background: [] }],
            ['link', 'clean']
          ]
        }
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      getPointsRule().then(res => {
        this.contentHtml = (res.data && res.data.contentHtml) || ''
      }).catch(error => {
        this.$message.error(error.message || '积分规则加载失败')
      }).finally(() => {
        this.loading = false
      })
    },
    save() {
      if (!this.contentHtml || this.contentHtml === '<p><br></p>') {
        this.$message.warning('请填写积分规则')
        return
      }
      this.saving = true
      savePointsRule({ contentHtml: this.contentHtml }).then(() => {
        this.$message.success('积分规则保存成功')
      }).catch(error => {
        this.$message.error(error.message || '积分规则保存失败')
      }).finally(() => {
        this.saving = false
      })
    }
  }
}
</script>

<style scoped>
.points-rule-page { padding: 20px; }
.editor-wrap { margin-bottom: 20px; }
.editor-wrap >>> .ql-container { min-height: 360px; }
</style>
